import React from 'react';

import styled from '../../styled';

const Flipper = ({ children, wrapperCss }) => {
  return (
    <Scene optionalStyles={wrapperCss}>
      <StyledFlipper>{children}</StyledFlipper>
    </Scene>
  );
};

export default Flipper;

const Scene = styled('div', {
  shouldForwardProp: (prop) => prop !== 'optionalStyles',
})`
  perspective: 600px;
  &:hover {
    & > * {
      transform: rotateY(180deg);
    }
  }
  ${({ optionalStyles }) => optionalStyles}
`;
const StyledFlipper = styled('div')`
  height: 100%;
  transition: transform 0.8s;
  transition-delay: 250ms;
  transform-style: preserve-3d;
  & > * {
    position: absolute;
    height: 100%;
    width: 100%;
    backface-visibility: hidden;
  }
  & > *:last-child {
    transform: rotateY(180deg);
  }
`;
